import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { PressControlComponent } from 'design/pressControl';
import { ParagraphComponent } from 'design/paragraph';
import { useAppState } from 'hooks/useAppState';
import { ThemeProviderComponent } from 'design/themeProvider';
import { MarginComponent } from 'design/margin';

export const ProdStackManagerFinishComplete = () => {
  const { prodStackInfo } = useAppState();

  const prodStackLoginURL = prodStackInfo?.loginURL;

  const {
    prodStackManager: { finishComplete: ownDictionary },
  } = useIntlDictionary();

  const goToProdStack = React.useCallback(() => {
    if (prodStackLoginURL) {
      window.open(prodStackLoginURL, '_self');
    }
  }, [prodStackLoginURL]);

  return (
    <ThemeProviderComponent mode="prodRegistraionComplete">
      <ParagraphComponent margin="l">
        {ownDictionary.titleText()}
      </ParagraphComponent>
      <MarginComponent top={44} />
      <div style={{ width: '430px' }}>
        <ParagraphComponent margin="l">
          {ownDictionary.detailsText(prodStackInfo?.firstLogin || '')}
        </ParagraphComponent>
        <MarginComponent top={64} />
        <ParagraphComponent>
          <PressControlComponent
            theme="accent"
            type="button"
            fill
            onPress={goToProdStack}
          >
            {ownDictionary.actionText}
          </PressControlComponent>
        </ParagraphComponent>
      </div>
    </ThemeProviderComponent>
  );
};
